<template>
	<Transition mode="out-in">
		<Suspense>
			<LoanApplicationEditor :loan-application-id="loanApplicationId" />
			<template #fallback>
				<div class="w-full h-full bg-gray-100">
					<div class="flex items-center justify-center gap-2 min-h-32 h-1/2">
						<p class="text-text-secondary">Offerteaanvraag laden...</p>
						<AppSpinner class="spinner" />
					</div>
				</div>
			</template>
		</Suspense>
	</Transition>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
const route = useRoute();
const loanApplicationId = route.params.loanApplicationId as string;
</script>

<style lang="scss" scoped>
.spinner {
	border-color: var(--text-secondary);
	border-bottom-color: transparent;
}

.v-enter-active,
.v-leave-active {
	transition: opacity 0.25s ease-in-out;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>
